import * as Yup from 'yup';
import * as formValidation from 'utils/formValidation';

import React, { useState } from 'react';

import { Formik } from 'formik';
import { VerifyAddress } from 'utils/verifyAddress';
import { editUser } from 'utils/editUser';
import { logError } from 'utils/errorLogger';
import ShippingAddressForm from 'components/ShippingAddress/ShippingAddressForm';
import ShippingAddressUpdateModal from 'components/ShippingAddress/ShippingAddressUpdateModal';
import { mutate } from 'swr';
import { useMjrApiUser } from 'utils/swrCalls';
import * as site from 'utils/getSite';

const ShippingAddress = (props) => {
  const {
    buttonText, setOpen, type, callbackFunction, hideNameFields,
  } = props;
  const { data: user } = useMjrApiUser();
  const [state, setState] = useState({
    hasMessage: false,
    message: '',
    submit: false,
    submittedAddress: null,
    suggestedAddress: null,
  });
  const [modalState, setModalState] = useState({
    showModal: false,
  });

  // form default
  const values = {
    firstName: user?.firstName,
    lastName: user?.lastName,
    address1: user?.address?.addressLine1,
    address2: user?.address?.addressLine2,
    city: user?.address?.city,
    state: user?.address?.state,
    zipCode: user?.address?.zipCode,
    phone: user?.phone,
  };
  // add email optOut for montblanc site
  if (site.getSite.includes('montblanc')) {
    // values.emailOptOut = (user?.emailOptOut !== undefined ? user?.emailOptOut : 1);
    // Temp setting email to opt in, remove and uncomment above to return to normal use
    values.emailOptOut = (1);
  }

  // form validation
  const validationSchema = Yup.object({
    firstName: formValidation?.firstName,
    lastName: formValidation?.lastName,
    address1: formValidation?.address1,
    city: formValidation?.city,
    state: formValidation?.state,
    zipCode: formValidation?.zipCode,
    phone: formValidation?.phone,
  });

  const setError = (message) => {
    setState({
      hasMessage: true,
      message,
      submit: false,
    });
  };

  /**
   * Submit
   *
   * @param formValues
   *
   * Submit Form values and modify for edit user function
   */
  const submit = async (formValues) => {
    setState({
      hasMessage: false,
      message: '',
      submit: true,
    });
    const formData = { ...user };
    formData.firstName = formValues?.firstName;
    formData.lastName = formValues?.lastName;
    formData.phone = formValues?.phone;
    formData.address = {
      id: formData?.address?.id,
      addressLine1: formValues?.address1,
      addressLine2: formValues?.address2,
      city: formValues?.city,
      state: formValues?.state,
      zipCode: formValues?.zipCode,
      country: formValues?.country || process.env.NEXT_PUBLIC_US_ISO_CODE,
    };
    formData.emailOptOut = formValues?.emailOptOut;

    // ParcelPro doesn't accept firstname with more than 15 chars long and lastname with more than 20 chars long.
    if (formData.firstName.length > 15) {
      setState({
        hasMessage: true,
        message: 'Firstname cannot be more than 15 characters long.',
        submit: false,
      });
      return;
    }
    if (formData.lastName.length > 20) {
      setState({
        hasMessage: true,
        message: 'Lastname cannot be more than 20 characters long.',
        submit: false,
      });
      return;
    }

    const VerifyAddressResponse = await VerifyAddress(formData.address);
    if (VerifyAddressResponse?.data?.isValid) {
      if (type !== 'payment_address') {
        await editUser(formData)
          .then((response) => {
            const status = response?.status;
            if (status === 204 || status === 200) {
              // update redux
              mutate(`${process.env.NEXT_PUBLIC_PROXY_MJR_API_URL}/api/customer/get`);
              // clean messages
              setState({
                hasMessage: false,
                message: '',
                submit: false,
              });
              // close modal
              setOpen(false);
            } else if (status === 400) {
              logError(response, 'editUser(1) - /components/ShippingAddress/ShippingAddressForm/index.js');
              setError('The information you submitted could not be processed.');
            } else {
              logError(response, 'editUser(2) - /components/ShippingAddress/ShippingAddressForm/index.js');
              setError('There was an issue with the server. Please try again later.');
            }
          })
          .catch((error) => {
            logError(error, 'editUser(3) - /components/ShippingAddress/ShippingAddressForm/index.js');
            setError('There was an issue with the server. Please try again later.');
          });
      } else if (VerifyAddressResponse?.data?.suggestedAddress) {
        setState({
          hasMessage: true,
          message: '',
          submit: false,
          suggestedAddress: VerifyAddressResponse?.data?.suggestedAddress,
          submittedAddress: formData,
        });
        setModalState({ showModal: true });
      } else {
        callbackFunction(formData);
        setState({
          hasMessage: false,
          message: '',
          submit: false,
        });
      }
    } else {
      logError(VerifyAddressResponse, 'VerifyAddress - /components/ShippingAddress/ShippingAddressForm/index.js');
      setError(VerifyAddressResponse?.data?.message);
    }
  };

  return (
    <>
      <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
        {(props) => <ShippingAddressForm {...props} buttonText={buttonText} message={state} submitting={state.submit} hideNameFields={hideNameFields} />}
      </Formik>
      <ShippingAddressUpdateModal submitAddressFunction={callbackFunction} addressState={state} modalState={modalState} modalSetter={setModalState} />
    </>
  );
};

export default ShippingAddress;
